import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";

interface MobileFieldProps {
  label?: string;
  type?: any;
  mobileField: string;
  value: string;
  setValue: (mobileField: string, value: string) => void;
  setError?: (mobileField: string, error: boolean) => void;
  placeholder?: string;
  validation?: (value: string) => boolean;
  errorMessage?: string;
  error?: boolean;
  required?: boolean;
  rows?: number;
  disabled?: boolean;
  design?: "flex" | "default";
  passCol?: string;
  maxLength?: number;
  tabIndex?: number;
  showClearIcon?: boolean;
  autoComplete?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const MobileField: FC<MobileFieldProps> = ({
  label,
  type = "text",
  mobileField,
  value,
  setValue,
  setError,
  placeholder = "",
  validation = () => true,
  errorMessage = "Invalid input",
  error = false,
  required = false,
  rows = 3,
  disabled,
  design = "default",
  passCol,
  tabIndex,
  showClearIcon = false,
  autoComplete = 'on',
  onBlur
}) => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    
    window.addEventListener("resize", handleResize);
    
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    let inputValue = e.target.value;

    inputValue = inputValue.replace(/\D/g, "");

    inputValue = inputValue
        .slice(0, 10) 
        .replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3"); 
    setValue(mobileField, inputValue);

    if (setError) {
        setError(mobileField, false);
    }
  };

  const handleClear = () => {
    setValue(mobileField, "");
    if (setError) {
      setError(mobileField, false);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!validation(value) && setError) {
      setError(mobileField, true);
    }
    onBlur?.(e);
  };

  const flexClass = design === "flex" && windowWidth > 768 ? "d-flex align-items-center" : "";
  const labelWidthClass = design === "flex" && windowWidth > 768 ? "col-3" : "";
  const passColClass = windowWidth > 768 ? passCol : "";
  return (
    <FormGroup className={flexClass}>
      {label && (
        <Label for={mobileField} className={`${design === "flex" ? "mr-5 " : ""}${labelWidthClass}`}>
          {label}
          {required && <span className="text-danger ml-2">*</span>}
        </Label>
      )}
      <div className={`${passColClass} position-relative`}>
        {error && <FormFeedback className="d-block mt-1">{errorMessage}</FormFeedback>}
        <Input
          id={mobileField}
          name={mobileField}
          type={type}
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlur}
          tabIndex={tabIndex}
          placeholder={placeholder}
          disabled={disabled}
          invalid={error}
          rows={type === "textarea" ? rows : undefined}
          autoComplete={autoComplete}
        />
        {showClearIcon && value && (
          <i 
            className="icon-close position-absolute" 
            style={{ 
              right: '10px', 
              top: '50%', 
              transform: 'translateY(-50%)', 
              cursor: 'pointer',
              color: '#666'
            }}
            onClick={handleClear}
          />
        )}
      </div>
    </FormGroup>
  );
};

export default MobileField;
